/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const TitleComponent = styled(Box)(({theme}) => ({
  height: '60px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 4),
  background: theme.palette.figma_gray_light_4?.main,
  borderRadius: '8px',
}));

export const TitleText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_5?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const TitleHotKeyBox = styled(Box)(({theme}) => ({
  borderRadius: '8px',
  border: '1px solid #3E88C5',
  padding: theme.spacing(1, 2, 1, 1),
}));
